import reengagementEmails from './reengagementEmails';
import rewardEmails from './rewardEmails';
import syncNetworkEmails from './syncNetworkEmails';
import welcomeEmails from './welcomeEmails';
import userInviteEmails from './userInviteEmails';
import mentorEmails from './mentorEmails';
import jobApplicationEmails from './jobApplicationEmails';

const emailBlocks = {
  ...reengagementEmails,
  ...rewardEmails,
  ...syncNetworkEmails,
  ...welcomeEmails,
  ...userInviteEmails,
  ...mentorEmails,
  ...jobApplicationEmails,
};

export default emailBlocks;


// WEBPACK FOOTER //
// ./src/emails/previews/index.js